import { Grid, Card, CardHeader, CardContent, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { ShoppingCart, HourglassBottom, LocalShipping, AccountBalance } from '@mui/icons-material';
import { useQuery } from '@tanstack/react-query';
import { PageHeader } from '../../components/PageHeader';
import { StatCard } from '../../components/StatCard';
import { MiniBarChart } from '../../components/MiniBarChart';
import { StatusBadge } from '../../components/StatusBadge';
import { EmptyState } from '../../components/EmptyState';
import { dealerOrdersApi } from '../../api/dealerOrders.api';

const inr = (n = 0) => `₹${Number(n).toLocaleString('en-IN')}`;
const num = (n = 0) => Number(n).toLocaleString('en-IN');

export function OrderAnalyticsDashboardPage() {
  const dash = useQuery({ queryKey: ['dealer-orders', 'analytics'], queryFn: () => dealerOrdersApi.analytics() });
  const d = dash.data;
  const statusData = d ? Object.entries(d.byStatus).map(([label, value]) => ({ label: label.replace(/_/g, ' '), value, color: '#1e40af' })) : [];

  return (
    <>
      <PageHeader title="Order Analytics" subtitle="EVCPD dealer order pipeline and fulfilment health." />

      <Grid container spacing={2} mb={1}>
        <Grid item xs={12} sm={6} lg={3}><StatCard gradient color="#1e40af" label="Total Orders" value={num(d?.totalOrders)} icon={<ShoppingCart />} hint={`${num(d?.open)} open`} /></Grid>
        <Grid item xs={12} sm={6} lg={3}><StatCard gradient color="#d97706" label="Pending Approval" value={num(d?.pendingApproval)} icon={<HourglassBottom />} /></Grid>
        <Grid item xs={12} sm={6} lg={3}><StatCard gradient color="#0d9488" label="In Fulfilment" value={num(d?.inFulfilment)} icon={<LocalShipping />} hint={`${num(d?.delivered)} delivered`} /></Grid>
        <Grid item xs={12} sm={6} lg={3}><StatCard gradient color="#7c3aed" label="Order Value" value={inr(d?.totalValue)} icon={<AccountBalance />} /></Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%' }}>
            <CardHeader title="Orders by Status" titleTypographyProps={{ variant: 'subtitle1' }} />
            <CardContent>{statusData.length ? <MiniBarChart data={statusData} valueFormatter={num} /> : <EmptyState title="No orders yet" dense />}</CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%' }}>
            <CardHeader title="Recent Orders" titleTypographyProps={{ variant: 'subtitle1' }} />
            <CardContent sx={{ p: 0, overflowX: 'auto' }}>
              {(d?.recent.length ?? 0) === 0 ? <EmptyState title="No orders yet" dense /> : (
                <Table size="small">
                  <TableHead><TableRow><TableCell>Order</TableCell><TableCell align="right">Value</TableCell><TableCell>Status</TableCell></TableRow></TableHead>
                  <TableBody>
                    {(d?.recent ?? []).map((o) => (
                      <TableRow key={o.id} hover>
                        <TableCell>{o.orderCode}</TableCell>
                        <TableCell align="right">{inr(o.grandTotal)}</TableCell>
                        <TableCell><StatusBadge status={o.status} /></TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}
